// extracted by mini-css-extract-plugin
module.exports = {"skelet":"Skelet_skelet__Z3L3p","wheeeee":"Skelet_wheeeee__aGXk5","invert":"Skelet_invert__PLaK3"};